
class SideSearch extends HTMLElement {
  input; resultsContainer; form; empty;

  static selectors = {
    input: 'input[name="q"]',
    results: '[data-search-results]',
    empty: '[data-empty]',
    searchs: '#search-results'
  }

  constructor(){
    super();
    this.init();
  }

  init = () => {
    this.input = this.querySelector(SideSearch.selectors.input);
    this.resultsContainer = this.querySelector(SideSearch.selectors.results);
    this.empty = this.querySelector(SideSearch.selectors.empty);
    this.form = this.querySelector('form');

    this.input.addEventListener('input', this.search);
  }

  search = (event) => {
    const formdata = new FormData(this.form);
    if(formdata.get('q') == undefined || formdata.get('q') == '' || formdata.get('q') == null){
      this.setEmpty(true);
    } else {
      this.setEmpty(false);
      const queryString = new URLSearchParams(new FormData(this.form)).toString();
      const url = window.Shopify.routes.root + 'search/suggest?'+queryString+"&section_id=predictive-search";
  
      axios.get(url)
      .then((response) => {
        try {
          const resultsMarkup = new DOMParser().parseFromString(response.data, 'text/html').querySelector(SideSearch.selectors.searchs).innerHTML;
          this.resultsContainer.innerHTML = resultsMarkup;
        } catch (e){
          Utils.error(window.lang.errors.generic, e);
        }
      })
      .catch((error) => {
        Utils.error(error.response.data.description || error.message, error);
      });
    }
  }

  setEmpty = (status) => {
    if(status){
      this.empty.classList.remove('d-none');
      this.resultsContainer.innerHTML = '';
    }
    else
      this.empty.classList.add('d-none');
  }
  
}
if (!window.customElements.get("side-search")) {
  window.customElements.define("side-search", SideSearch);
}